<template>
    <div class="z-page-nav" :class="{ 'z-page-nav--with-back-link': data['back-link'] }">
        <div class="z-page-nav__link-wrapper z-page-nav__link-wrapper--left">
            <z-link
                size="m"
                :href="data.prev ? data.prev.url : 'javascript:void(0)'"
                :class="{ 'is-disabled': !(data.prev && data.prev.url) }"
                :icon="arrow"
                icon-position="left"
                inline-flex
                :underlined="false"
                dir="left"
            >
                <span class="hide-me--mobile" v-html="prevText"/>
            </z-link>
        </div>
        <div class="z-page-nav__button-wrapper">
            <z-button
                v-if="data['back-link']"
                kind="bordered"
                tag="a"
                size="s"
                :href="data['back-link']"
                class="z-page-nav__button"
            >
                <span class="z-page-nav__button-text" v-html="buttonText"></span>
                <template v-slot:right>
                    <z-icon
                        width="36"
                        height="36"
                        name="arrows/round-arrow-big"
                        dir="right"
                    />
                </template>
            </z-button>
        </div>
        <div class="z-page-nav__link-wrapper">
            <z-link
                size="m"
                :href="data.next ? data.next.url : 'javascript:void(0)'"
                :class="{ 'is-disabled': !(data.next && data.next.url) }"
                :icon="arrow"
                icon-position="right"
                :underlined="false"
                dir="right"
                inline-flex
            >
                <span class="hide-me--mobile" v-html="nextText"/>
            </z-link>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import { localize } from '@/utils/i18n'

const props = defineProps({
    data: {
        required: true,
        type: Object
    },
    buttonText: {
        type: String,
        default: localize({
            ru: 'Вернуться к списку',
            en: 'Back to list',
            cn: 'Back to list'
        })
    }
})

const arrow = 'arrows/caret'
const defaultText = {
    prev: localize({
        ru: 'Предыдущий',
        en: 'Preview',
        cn: 'Preview'
    }),
    next: localize({
        ru: 'Следующий',
        en: 'Next',
        cn: 'Next'
    })
}

const nextText = computed(() => {
    const name = getFormatedTitle(props.data.next?.name)
    return name || defaultText.next
})

const prevText = computed(() => {
    const name = getFormatedTitle(props.data.prev?.name)
    return name || defaultText.prev
})

const getFormatedTitle = (title, maxLength = 80) => {
    if (!title) return title
    let trimmedString = title.substr(0, maxLength)
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')))

    return title.length > maxLength ? `${trimmedString}...` : title
}


defineExpose({
    props
})
</script>

<style lang="scss" src="./index.scss"></style>
